import '../../httpservices/core/ajax.httpservice.core';

class AccountAccessHttpService {

    RemoveProxyAccess(userid) {
        return $.post('Patient/AccountAccess/RemoveProxyAccess', userid );
    }

    SendInvite(inviteModel) {
        return $.post('Patient/AccountAccess/InviteUser', inviteModel);
    }

    GetConsentInfo() {
        return $.get('Patient/AccountAccess/GetConsentInfo')
    }

    VerifyConsent(userId, allow) {
        return $.post('Patient/AccountAccess/VerifyConsent', { userId, allow })
    }

    RedirectToPersonelInfo(consentsSigned, consentsRemoved) {
        return $.post('Patient/AccountAccess/RedirectToPersonelInfo', { consentsSigned, consentsRemoved })
    }

}

export const AccountAccessHttpSvc = new AccountAccessHttpService();